import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-fac87584")
const _hoisted_1 = { class: "info-detail-container" }
const _hoisted_2 = { class: "item-wrap" }
const _hoisted_3 = { class: "right" }
const _hoisted_4 = { class: "info" }
const _hoisted_5 = {
  key: 0,
  class: "imgs"
}
const _hoisted_6 = {
  key: 1,
  class: "videos"
}
const _hoisted_7 = { class: "time" }
const _hoisted_8 = {
  key: 2,
  class: "operation"
}
const _hoisted_9 = { class: "date" }
const _hoisted_10 = { class: "right-menu" }
const _hoisted_11 = { class: "text" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "cup" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "评论", -1)
const _hoisted_14 = {
  key: 3,
  class: "bottom-container"
}
const _hoisted_15 = {
  key: 0,
  class: "nice"
}
const _hoisted_16 = { class: "nice-item" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 1,
  class: "cup"
}
const _hoisted_19 = ["onClick", "onTouchstart"]
const _hoisted_20 = { class: "person" }
const _hoisted_21 = { class: "content" }
const _hoisted_22 = { class: "person" }
const _hoisted_23 = { class: "reply-wrap" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 回复 ")
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "line_2" }
const _hoisted_27 = { class: "field-wrap" }
const _hoisted_28 = ["placeholder"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_preview_video = _resolveComponent("preview-video")!
  const _component_van_field = _resolveComponent("van-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_image, {
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.toFarmerDetail(_ctx.detailData.farmerId, 1)), ["stop"])),
        radius: "3px",
        fit: "cover",
        class: "left",
        src: 
          _ctx.detailData.farmerHeadImg && _ctx.detailData.farmerHeadImg.length > 0
            ? _ctx.detailData.farmerHeadImg[0].url
            : 'https://qnui.xfarmer.com/xfarmer-ui/h5FarmerSpace/%E7%BB%84%20989%402x.png'
        
      }, null, 8, ["src"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "name",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.toFarmerDetail(_ctx.detailData.farmerId, 1)), ["stop"]))
        }, _toDisplayString(_ctx.detailData && _ctx.detailData.farmerName), 1),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.detailData && _ctx.detailData.content), 1),
        (_ctx.detailData.imgList && _ctx.detailData.imgList.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailData.imgList, (item, index) => {
                return (_openBlock(), _createBlock(_component_van_image, {
                  class: "img",
                  radius: "0.25rem",
                  key: item.id,
                  src: item.url,
                  fit: "cover",
                  onClick: _withModifiers(($event: any) => (_ctx.onPreviewImg(index)), ["stop"])
                }, null, 8, ["src", "onClick"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.detailData.videoList && _ctx.detailData.videoList.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailData.videoList, (videos) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "poster-wrap",
                  key: videos.id
                }, [
                  _createVNode(_component_van_image, {
                    class: "poster",
                    src: videos.coverImg,
                    radius: "0.25rem",
                    fit: "cover"
                  }, null, 8, ["src"]),
                  _createVNode(_component_van_image, {
                    class: "play",
                    src: "https://qnui.xfarmer.com/xfarmer-ui/h5FarmerSpace/bofang.png",
                    fit: "cover",
                    onClick: _withModifiers(($event: any) => (_ctx.onPreviewVideo(videos.url)), ["stop"])
                  }, null, 8, ["onClick"]),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(videos.timeStr), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "location",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.toResource(_ctx.detailData.sourceId)), ["stop"]))
        }, _toDisplayString(_ctx.detailData && _ctx.detailData.address), 1),
        _createElementVNode("div", {
          class: "source",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.toResource(_ctx.detailData.sourceId)), ["stop"]))
        }, _toDisplayString(_ctx.detailData && _ctx.detailData.sourceName), 1),
        (_ctx.detailData.createTime)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.transfromDate(_ctx.detailData.createTime)), 1),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_van_image, {
                  class: "menu",
                  src: "https://qnui.xfarmer.com/xfarmer-ui/h5FarmerSpace/more.png",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.onShow(_ctx.item)), ["stop"]))
                }),
                _createElementVNode("div", {
                  class: "drawer",
                  style: _normalizeStyle(_ctx.detailData.isShow ? 'width:10rem' : 'width:0rem')
                }, [
                  _createElementVNode("div", {
                    class: "inner-content",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onZan && _ctx.onZan(...args)), ["stop"]))
                  }, [
                    _createVNode(_component_van_image, {
                      class: "zan",
                      src: "https://qnui.xfarmer.com/xfarmer-ui/h5FarmerSpace/baiaixin.png"
                    }),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.detailData.zan ? "已赞" : "赞"), 1)
                  ]),
                  _hoisted_12,
                  _createElementVNode("div", {
                    class: "inner-content",
                    onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onComment && _ctx.onComment(...args)), ["stop"]))
                  }, [
                    _createVNode(_component_van_image, {
                      class: "zan",
                      src: "https://qnui.xfarmer.com/xfarmer-ui/h5FarmerSpace/pinglun.png"
                    }),
                    _hoisted_13
                  ])
                ], 4)
              ])
            ]))
          : _createCommentVNode("", true),
        (
            (_ctx.detailData.zanList && _ctx.detailData.zanList.length > 0) ||
            (_ctx.detailData.comments && _ctx.detailData.comments.length > 0)
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (_ctx.detailData.zanList && _ctx.detailData.zanList.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_van_image, {
                        class: "icon",
                        src: "https://qnui.xfarmer.com/xfarmer-ui/h5FarmerSpace/lvaixin.png"
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailData.zanList, (item, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: index,
                          onClick: _withModifiers(($event: any) => (_ctx.toFarmerDetailtwo(item, item.userType)), ["stop"])
                        }, _toDisplayString(index == 0 ? "" : ",") + _toDisplayString(item.name), 9, _hoisted_17))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (
              _ctx.detailData.zanList &&
              _ctx.detailData.zanList.length > 0 &&
              _ctx.detailData.comments &&
              _ctx.detailData.comments.length > 0
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_18))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailData.comments, (comment) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(_ctx.acDelId == comment.id ? 'active chat' : 'chat'),
                  key: comment.id,
                  onClick: _withModifiers(($event: any) => (_ctx.onClickReply(comment)), ["stop"]),
                  onTouchstart: _withModifiers(($event: any) => (_ctx.touchStart(comment.id, comment.canDel)), ["stop"]),
                  onTouchend: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.touchEnd()), ["stop"]))
                }, [
                  (!comment.replyName)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_20, [
                          _createTextVNode(_toDisplayString(comment.name), 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.initCreateFn(comment.createTime)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_21, _toDisplayString(comment.content), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_22, [
                          _createTextVNode(_toDisplayString(comment.name), 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.initCreateFn(comment.createTime)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _hoisted_24,
                          _createElementVNode("span", {
                            class: "line_1",
                            onClick: _withModifiers(($event: any) => (
                    _ctx.toFarmerDetail(
                      (comment.replyUserType = 1
                        ? comment.replyFarmerId
                        : comment.replyUserId),
                      comment.replyUserType
                    )
                  ), ["stop"])
                          }, _toDisplayString(comment.replyName) + "：", 9, _hoisted_25),
                          _createElementVNode("span", _hoisted_26, _toDisplayString(comment.content), 1)
                        ])
                      ], 64)),
                  (_ctx.comId == comment.id)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "del-com",
                        onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.delCom && _ctx.delCom(...args)), ["stop"]))
                      }, " 删除 "))
                    : _createCommentVNode("", true)
                ], 42, _hoisted_19))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_preview_video, {
      visible: _ctx.previewVideo,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => (_ctx.previewVideo = $event)),
      url: _ctx.videoUrl
    }, null, 8, ["visible", "url"]),
    _createElementVNode("div", _hoisted_27, [
      _createVNode(_component_van_field, null, {
        input: _withCtx(() => [
          _withDirectives(_createElementVNode("input", {
            class: "reply-content",
            ref: "replyField",
            type: "search",
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.replyMessage = $event)),
            placeholder: _ctx.replyPlaceholder,
            maxlength: "255"
          }, null, 8, _hoisted_28), [
            [_vModelText, _ctx.replyMessage]
          ])
        ]),
        button: _withCtx(() => [
          _createElementVNode("button", {
            class: "field",
            onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onConfirmReply && _ctx.onConfirmReply(...args)), ["stop"]))
          }, "确定")
        ]),
        _: 1
      })
    ])
  ]))
}